import { z } from 'zod';
import { PRODUCT_CATEGORY_DESCRIPTION_MAX_LENGTH, PRODUCT_CATEGORY_NAME_MAX_LENGTH, PRODUCT_CATEGORY_SLUG_MAX_LENGTH, } from '../constants/products.js';
import { idSchema, isoDateTimeSchema } from './common.js';
const optionalCategoryText = (max) => z.string().trim().max(max).nullish();
export const productCategoryAssignmentSchema = z.object({
    categoryId: idSchema,
    isPrimary: z.boolean().default(false),
});
export const productCategorySchema = z.object({
    id: idSchema,
    name: z.string(),
    nameEn: z.string().nullable(),
    slug: z.string(),
    description: z.string().nullable(),
    parentId: idSchema.nullable(),
    sortOrder: z.number().int().min(0),
    isActive: z.boolean(),
    productCount: z.number().int().min(0),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
/** Flat, stably sorted tree representation; `depth` and `path` avoid recursive API types. */
export const productCategoryTreeNodeSchema = productCategorySchema.extend({
    depth: z.number().int().min(0),
    path: z.array(idSchema).min(1),
    hasChildren: z.boolean(),
});
export const productCategoryTreeResponseSchema = z.object({
    data: z.array(productCategoryTreeNodeSchema),
});
export const productCategoryWriteSchema = z.object({
    name: z.string().trim().min(1).max(PRODUCT_CATEGORY_NAME_MAX_LENGTH),
    nameEn: optionalCategoryText(PRODUCT_CATEGORY_NAME_MAX_LENGTH),
    slug: z
        .string()
        .trim()
        .toLowerCase()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/u)
        .max(PRODUCT_CATEGORY_SLUG_MAX_LENGTH)
        .optional(),
    description: optionalCategoryText(PRODUCT_CATEGORY_DESCRIPTION_MAX_LENGTH),
    parentId: idSchema.nullish(),
    sortOrder: z.number().int().min(0).max(1_000_000).optional(),
    isActive: z.boolean().default(true),
});
export const productCategoryCreateSchema = productCategoryWriteSchema;
export const productCategoryUpdateSchema = productCategoryWriteSchema
    .partial()
    .refine((value) => Object.values(value).some((entry) => entry !== undefined), {
    message: 'Mindestens ein Feld muss aktualisiert werden.',
});
export const productCategoryListQuerySchema = z.object({
    q: z.string().trim().min(1).max(200).optional(),
    includeInactive: z.preprocess((value) => value === 'true' || value, z.boolean().default(false)),
});
export const productCategoryAssignmentsWriteSchema = z
    .array(productCategoryAssignmentSchema)
    .max(100)
    .superRefine((assignments, context) => {
    const ids = new Set();
    let primaryCount = 0;
    assignments.forEach((assignment, index) => {
        if (ids.has(assignment.categoryId)) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: [index, 'categoryId'],
                message: 'Eine Kategorie darf nur einmal zugeordnet werden.',
            });
        }
        ids.add(assignment.categoryId);
        if (assignment.isPrimary) {
            primaryCount += 1;
        }
    });
    if (primaryCount > 1) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Es darf höchstens eine primäre Kategorie geben.',
        });
    }
});
//# sourceMappingURL=product-category.js.map